import { partial } from 'io-ts/lib/Decoder';

import { constants } from '@bedc/constants';

import { Request as FilterRequest } from '../../generic/search/filter/Request';

export const Request = partial({
	filter: FilterRequest({
		standardFilterFields: constants.client.search.listStandardFilterFields,
		dateFilterFields: [] as const,
		stageStatusFilterFields: [] as const,
		booleanFilterFields: [] as const,
	}),
});
